import angular from "angular"

const AccountService = (Locale, $http, RestApi) => {
  return RestApi._AccountClass
}

angular.module("uCountitUiApp").service("Account", ["Locale", "$http", "RestApi", AccountService])
